import type { FC } from 'react';

import { Textfit } from '@wwe-portal/ui/components/text-fit';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { SoldOut } from '@wwe-portal/ui/features/store-revamp';
import lockIconWebp from '@wwe-portal/ui/assets/images/flagship/lock-icon.webp';

import { OfferTimeCountDown } from '../component/offer-time-countdown';
import { NotifPip } from '../flagship/notif-pip';
import { type OfferCardProps } from '../type';
import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';

import { OfferHeader } from './offer-header';
import { OfferItems } from './offer-items';
import { OfferLayout } from './offer-layout';
import { ResponseOfferCardBackground } from './responsive-offer-card-background';
import { StockQuantity } from './stock-quantity';

export const OfferSingle2Card: FC<OfferCardProps> = ({
  id,
  backgroundImage,
  dynamicBackgroundImage,
  title,
  price,
  strikethroughPrice,
  endDate,
  items,
  quantity,
  maxQuantity,
  style,
  onClick,
  onPurchaseClick,
  overlay,
  hasPip,
  hasContest,
  badgeIcon,
  badgeText,
  type,
  isBlocked = false,
  showStock,
  soldOut,
}) => {
  return (
    <div className="relative" data-id={id}>
      <ClickableDiv
        className="aspect-single-2 font-poppins"
        onClick={onClick}
        style={style}
      >
        <div className="absolute inset-0 overflow-clip rounded-b-[10px]">
          <div className="absolute -bottom-[calc(700%/354)] -left-[calc(700%/360)] -right-[calc(700%/360)] -top-[calc(700%/354)]">
            <ResponseOfferCardBackground
              backgroundImage={backgroundImage}
              dynamicBackgroundImage={dynamicBackgroundImage}
              type={type}
            />
          </div>
        </div>
        <OfferLayout
          cardType={OfferCardTypeEnum.SINGLE2}
          footer={
            price != null && (
              <ClickableDiv
                className="absolute bottom-0 left-0 right-0 top-0 px-1 font-semibold text-white"
                data-slot="price"
                onClick={onPurchaseClick}
              >
                <Textfit
                  className="flex h-full w-full items-center justify-center capitalize"
                  max={16}
                  mode="single"
                >
                  <div className="drop-shadow-text-2 flex items-center justify-center gap-x-2">
                    {strikethroughPrice ? (
                      <div className="text-2xs flex items-center justify-center gap-x-1 pr-[2px] text-left line-through">
                        {strikethroughPrice}
                      </div>
                    ) : null}
                    <div className="flex items-center justify-center gap-x-1">
                      {price}
                    </div>
                  </div>
                  {Boolean(isBlocked) && (
                    <img
                      alt="locked"
                      className="absolute inset-y-[15%] right-1 h-[21px] md:h-[22px]"
                      src={lockIconWebp}
                    />
                  )}
                </Textfit>
              </ClickableDiv>
            )
          }
          header={<OfferHeader maxFont={14}>{title}</OfferHeader>}
          items={
            <OfferItems itemWidth="calc(4000%/168)" items={items} maxItem={1} />
          }
          stockQuantity={
            <StockQuantity
              badgeIcon={badgeIcon}
              badgeText={badgeText}
              hasContest={hasContest}
              maxQuantity={maxQuantity}
              quantity={quantity}
              showStock={showStock && !soldOut}
              type={type}
            />
          }
          timeLeft={endDate ? <OfferTimeCountDown endDate={endDate} /> : null}
        />
        {overlay}
      </ClickableDiv>
      {hasPip && !soldOut ? <NotifPip /> : null}
      {soldOut && <SoldOut type={OfferCardTypeEnum.SINGLE2} />}
    </div>
  );
};
